// Manages state for all actions related to the Geo Bar

import { geoBarReducer, geoBarInitialState } from 'catena/er2_ui'

// Override the behavior of the geo bar, or disable it here
const initialState = Object.assign({}, geoBarInitialState, {})

export default geoBarReducer
